import { render, staticRenderFns } from "./NewEditBirthday.vue?vue&type=template&id=5ed1b6bc&"
import script from "../../models/coupon/new-edit-birthday.ts?vue&type=script&lang=ts&"
export * from "../../models/coupon/new-edit-birthday.ts?vue&type=script&lang=ts&"
import style0 from "./NewEditBirthday.vue?vue&type=style&index=0&id=5ed1b6bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports